import React, { useContext, useState } from 'react'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import styled from 'styled-components'
import CreationToolFont from '../../../../types/font'
import { preloadFont } from '../../../../utils/preload'
import SelectListComponent from '../../../select-list'
import { CreationSourceEditorContext } from '../../manager'

const BASE_FONT_SIZE = 18

const SelectList = styled(SelectListComponent)`
    width: 100%;
`

const CreationSourceEditorCaptionFontDropdown = () => {
    const { captionStyle, setCaptionStyle, customFontUrl } = useContext(CreationSourceEditorContext)
    const [fonts, setFonts] = useState<CreationToolFont[]>(CreationToolFont.all())
    const { font: currentFont } = captionStyle

    useAsyncEffect(async () => {
        if (!customFontUrl) return

        try {
            // if custom font provided, load font with font family name
            await preloadFont(customFontUrl, CreationToolFont.fontFamily(CreationToolFont.Custom))
            setFonts([...CreationToolFont.all(), CreationToolFont.Custom])
        } catch (e) {
            console.log(e)
        }
    }, [customFontUrl, setFonts])

    const onChange = (font: CreationToolFont) => {
        setCaptionStyle({
            ...captionStyle,
            font,
        })
    }

    return (
        <SelectList
            {...{
                onChange,
                value: currentFont,
                options: fonts.map(font => ({
                    value: font,
                    label: (
                        <span
                            key={font}
                            style={{
                                fontFamily: CreationToolFont.fontFamily(font),
                                fontSize: `${Math.round(BASE_FONT_SIZE * CreationToolFont.scale(font))}px`,
                                fontWeight: CreationToolFont.fontWeight(font),
                                textTransform: CreationToolFont.isAllCaps(font) ? 'uppercase' : 'none',
                            }}
                        >
                            {CreationToolFont.title(font)}
                        </span>
                    ),
                })),
            }}
        />
    )
}

export default CreationSourceEditorCaptionFontDropdown
